import { render, staticRenderFns } from "./PopupStoryCardButton.vue?vue&type=template&id=743f68fb&"
import script from "./PopupStoryCardButton.vue?vue&type=script&lang=js&"
export * from "./PopupStoryCardButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports